
import React, { useState, useEffect } from "react";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useAuth } from "@/hooks/useAuth";
import { Menu } from "lucide-react";
import { TranslationButton } from "@/components/i18n/TranslationButton";
import { useTranslationEdit } from "@/contexts/TranslationEditContext";

import { Logo } from "./Logo";
import { DesktopNavigation } from "./DesktopNavigation";
import { MobileMenu } from "./MobileMenu";
import { HeaderActions } from "./HeaderActions";

export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const { user, isAuthenticated } = useAuth();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isEditMode } = useTranslationEdit();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <header className={cn(
      "sticky top-0 z-50 w-full border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60 transition-shadow duration-200",
      scrolled && "shadow-sm"
    )}>
      <div className="container flex h-14 items-center">
        <Logo isAuthenticated={isAuthenticated} />
        
        {user && (
          <>
            {/* Desktop Navigation */}
            <div className="hidden md:flex flex-1 items-center">
              <DesktopNavigation />
            </div>
            
            {/* Mobile Menu Button & Sheet */}
            <Sheet open={mobileMenuOpen} onOpenChange={setMobileMenuOpen}>
              <SheetTrigger asChild className="md:hidden">
                <Button variant="ghost" size="icon" disabled={isEditMode}>
                  <Menu className="h-5 w-5" />
                </Button>
              </SheetTrigger>
              <SheetContent side="left" className="w-[280px] sm:w-[350px]">
                <MobileMenu onOpenChange={setMobileMenuOpen} />
              </SheetContent>
            </Sheet>
          </>
        )}
        
        <div className="flex flex-1 items-center justify-between space-x-2 md:justify-end">
          <div className="w-full flex-1 md:w-auto md:flex-none">
            {/* Searchbar would go here */}
          </div>
          <HeaderActions authenticated={isAuthenticated} />
        </div>
      </div>
    </header>
  );
}
